import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface ImagePlaceholderPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
}

export const ImagePlaceholderIcon = observer('ImagePlaceholderIcon', ({ className, onClick }: ImagePlaceholderPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='none'
            height='20'
            onClick={onClick}
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path fill='#fill' d='M4.166 18.333a2.41 2.41 0 0 1-1.77-.729 2.411 2.411 0 0 1-.73-1.77V4.166c0-.695.243-1.285.73-1.771a2.41 2.41 0 0 1 1.77-.73h11.667a2.41 2.41 0 0 1 1.77.73c.487.486.73 1.076.73 1.77v11.667c0 .695-.243 1.285-.73 1.771a2.41 2.41 0 0 1-1.77.73H4.166Zm0-1.666h11.667c.236 0 .434-.08.593-.24.16-.16.24-.357.24-.594V4.167a.807.807 0 0 0-.24-.594.806.806 0 0 0-.593-.24H4.166a.808.808 0 0 0-.594.24.808.808 0 0 0-.24.594v11.666c0 .237.08.434.24.594.16.16.358.24.594.24ZM4.999 15l3.334-3.333 1.5 1.479 1.833-2.313L14.999 15H5Zm1.667-6.667c-.458 0-.85-.163-1.177-.49A1.603 1.603 0 0 1 5 6.667c0-.459.164-.85.49-1.177.326-.327.719-.49 1.177-.49.458 0 .85.163 1.178.49.326.326.489.718.489 1.177 0 .458-.163.85-.49 1.176-.326.327-.719.49-1.177.49Z'/>
        </SvgElement>
    );
});
